import React, { useEffect, useState } from "react";
import { generateQueryParams } from "../../../../utils/generateQueryParams";
import usePaginationHook from "../../../../hooks/usePaginationHook";
import { getPlayerBankDetails } from "../../../../redux/user/actions";
import { decryptData } from "../../../../utils/encryptUtils";
import { isValidJson } from "../../../../utils/validatorUtils";
import { useDispatch, useSelector } from "react-redux";
import WhatsAppWidget from "../../../components/WhatsAppWidget";
const ListBankDetails = ({ setPlayerBankId, setAutoPopulateBankDetails }) => {
  const pagination = usePaginationHook({});
  const dispatch = useDispatch();
  const [selectededBank, setSelectedBank] = useState({});
  const { bankDetails } = useSelector((state) => state.user);
  const [decryptedBank, setDecryptedBank] = useState({
    banks: [],
    count: 0,
    pagesize: 10,
  });
  useEffect(() => {
    fetchInitialData();
  }, []);
  useEffect(() => {
    if (bankDetails) {
      formatData(bankDetails);
    }
  }, [bankDetails]);

  const formatData = (encryptedData) => {
    const decryptedData = decryptData({
      data: encryptedData?.banks || "",
      key: localStorage.getItem("token"),
    });
    const decryptedBankDetails = isValidJson(decryptedData)
      ? JSON.parse(decryptedData)
      : [];
    setDecryptedBank({
      banks: decryptedBankDetails,
      count: encryptedData.count,
      pagesize: encryptedData.pagesize,
    });
    let tempObj = decryptedBankDetails.map((bank) => {
      return {
        id: bank.id,
        checked: false,
      };
    });
    setSelectedBank(tempObj);
  };
  const fetchInitialData = async () => {
    const query = generateQueryParams({ ...pagination.apiParams });
    dispatch(getPlayerBankDetails(query));
  };

  const handleCheckBoxClick = (item) => {
    if (item?.id === selectededBank?.id) {
      if (selectededBank?.checked === false) {
        setPlayerBankId(item);
        setAutoPopulateBankDetails(true);
      } else {
        setPlayerBankId({});
        setAutoPopulateBankDetails(false);
      }
      setSelectedBank({ id: item?.id, checked: !selectededBank?.checked });
    } else {
      setPlayerBankId(item);
      setAutoPopulateBankDetails(true);
      setSelectedBank({ id: item?.id, checked: true });
    }
  };

  return (
    <>
      <div className="WithdrawRequestBankSection">
        <div className="table-responsive">
          <table className="table text-white WithdrawTable">
            <thead>
              <tr>
                <th></th>
                <th scope="col">#</th>
                <th scope="col">Account Name</th>
                {/* <th scope="col">Type</th> */}
                <th scope="col">Account Number</th>
                <th scope="col">Created At</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(decryptedBank.banks) &&
                decryptedBank.banks.map((item, index) => {
                  return (
                    <tr onClick={() => handleCheckBoxClick(item)}>
                      <td>
                        <input
                          type="checkbox"
                          className=""
                          checked={
                            item.id === selectededBank.id &&
                            selectededBank.checked
                          }
                          id={item.id}
                          onClick={(e) => e.stopPropagation()}
                        ></input>
                        <label for={item.id}></label>
                      </td>
                      <th scope="row">
                        {pagination.apiParams.skip + index + 1}
                      </th>

                      <td style={{ color: "blue", cursor: "pointer" }}>
                        {item?.name}
                      </td>
                      {/* <td>{item?.type}</td> */}
                      <td>{item?.hint}</td>
                      <td>{item?.createdAt}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      <WhatsAppWidget />
    </>
  );
};
export default ListBankDetails;
